var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Column, CreateDateColumn, Entity, Index, PrimaryGeneratedColumn, UpdateDateColumn } from 'typeorm';
let UserReport = class UserReport {
    id;
    userAddress;
    type;
    contact;
    contactType;
    network;
    description;
    updatedAt;
    createdAt;
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], UserReport.prototype, "id", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", String)
], UserReport.prototype, "userAddress", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], UserReport.prototype, "type", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], UserReport.prototype, "contact", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], UserReport.prototype, "contactType", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], UserReport.prototype, "network", void 0);
__decorate([
    Column('text'),
    __metadata("design:type", String)
], UserReport.prototype, "description", void 0);
__decorate([
    UpdateDateColumn(),
    __metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], UserReport.prototype, "updatedAt", void 0);
__decorate([
    CreateDateColumn(),
    __metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], UserReport.prototype, "createdAt", void 0);
UserReport = __decorate([
    Entity({ name: 'user_report' })
], UserReport);
export { UserReport };
//# sourceMappingURL=module.js.map